export default async function (opt) {
    let url;
    if(opt.byTheme){
        url = opt.baseServerPath + 'api/getScrollNewsLinksMapByTheme.do' + '?newsId=' + opt.newsId + '&lang=' + opt.lang + '&siteName=' + opt.subsiteName;
    } else {
        url = opt.baseServerPath + 'api/getScrollNewsLinksMap.do' + '?siteName=' + opt.subsiteName + '&lang=' + opt.lang
    }

    let response = await fetch(url);
    let respJson = await response.json();
    delete (respJson[opt.newsId]);

    let newsList = Object.values(respJson);
    newsList.sort(function () {
        return Math.round(Math.random()) - 0.5
    });

    let responseMap = await fetch(opt.baseServerPath + 'api/getPinnedScrollNewsLinksMap.do' + '?siteName=' + opt.subsiteName + '&lang=' + opt.lang);
    let respMap = await responseMap.json();
    if (Object.keys(respMap).length) {
        let positionsPinned = Object.keys(respMap);
        positionsPinned.forEach(p => {
            let linkToNews = respMap[p];
            linkToNews.forEach(url => {
                if (url.toString().includes(opt.newsId.toString())) {
                    linkToNews.splice((linkToNews.indexOf(url)), 1);
                } else {
                    if (newsList.includes(url)) {
                        newsList.splice((newsList.indexOf(url)), 1);
                    }
                }
            })
        })

        let positions = Object.keys(respMap);
        positions.forEach(e => {
            if (newsList[e - 2] != null) {
                let randomNewsPinned = respMap[e][Math.floor(Math.random() * respMap[e].length)];
                if (randomNewsPinned) {
                    newsList[e - 2] = randomNewsPinned;
                }
            }
        })
    }

    return newsList.slice(0,10);
}